import {
    CAR_LIST_ERROR,
    CAR_LIST_LOADING,
    CAR_LIST_LOADING_END,
    CAR_LIST_SUCCESS,
    GET_CARS_DETAILS
} from '../types/carListTypes';

const initialState = {
    loading: false,
    error: false,
    cars: [],
    car: {},
    similarCars: [],
    filtersUsed: [],
    totalSimilarCars: 0,
    totalCar: 0
};
const carListingReducer = (state: any = initialState, data: any) => {
    switch (data.type) {
        case CAR_LIST_LOADING:
            return {
                ...state,
                loading: true
            };
        case CAR_LIST_LOADING_END:
            return {
                ...state,
                loading: false
            };
        case CAR_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                cars: data.payload.cars,
                totalCar: data.payload.total
            };

        case CAR_LIST_ERROR:
            return {
                ...state,
                loading: false,
                cars: [],
                error: true
            };
        case GET_CARS_DETAILS:
            return {
                ...state,
                loading: false,
                car: data.payload.car,
                similarCars: data.payload.similarCars,
                totalSimilarCars: data.payload.totalSimilarCars,
                filtersUsed: data.payload.filtersUsed
            };
        default:
            return state;
    }
};
export default carListingReducer;
